import React from 'react';
import PropTypes from 'prop-types';

import DefaultLayout from './deafult-layout';
import LightLayout from './light-layout';
import { APPLICATION_MODE } from '../../constants/layout';

const selectLayoutComponent = (mode) => {
    switch (mode) {
        case APPLICATION_MODE.LIGHT:
        case APPLICATION_MODE.EMBEDDED:
            return LightLayout;
        default:
            return DefaultLayout;
    }
};

const Layout = ({
    authors,
    children,
    courseTitle,
    exercises,
    extraInfo,
    homeworkStatus,
    isLoading,
    mode,
    profile,
    publicTitle,
    showModal,
    status,
    terminateHomework,
    tick,
}) => {
    const LayoutComponent = selectLayoutComponent(mode);

    return (
        LayoutComponent && (
            <LayoutComponent
                authors={authors}
                courseTitle={courseTitle}
                exercises={exercises}
                extraInfo={extraInfo}
                homeworkStatus={homeworkStatus}
                isLoading={isLoading}
                profile={profile}
                publicTitle={publicTitle}
                showModal={showModal}
                status={status}
                terminateHomework={terminateHomework}
                tick={tick}
            >
                {children}
            </LayoutComponent>
        )
    );
};

Layout.propTypes = {
    authors: PropTypes.array,
    children: PropTypes.node.isRequired,
    courseTitle: PropTypes.string,
    exercises: PropTypes.any,
    extraInfo: PropTypes.object,
    homeworkStatus: PropTypes.object,
    isLoading: PropTypes.bool,
    mode: PropTypes.oneOf([APPLICATION_MODE.LIGHT, APPLICATION_MODE.DEFAULT, APPLICATION_MODE.EMBEDDED, '']),
    profile: PropTypes.object,
    publicTitle: PropTypes.string,
    showModal: PropTypes.func,
    status: PropTypes.object,
    terminateHomework: PropTypes.func,
    tick: PropTypes.func,
};

export default Layout;
